
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({ name: 'FilterBarContentTypeItem' })
export default class FilterBarContentTypeItem extends Vue {
	@Prop({ default: 'div' }) tag: string;
	@Prop({ required: true }) active: boolean;
}
